import { render } from "./attention-required-settings.vue?vue&type=template&id=06eb1aed&lang=pug"
import script from "./attention-required-settings.vue?vue&type=script&setup=true&lang=js"
export * from "./attention-required-settings.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__